import React, {
  Component
} from 'react';
import {
  Container,
  Menu,
  Accordion,
  Image,
  Icon
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import _ from 'lodash';

const navStyle = {

};

const logo = require('../assets/img/Sistel.png');
class NavigationView extends Component {

  constructor (props) {
    super(props);
    let items = [
      {
        key: 'home',
        name: 'home',
        as: Link,
        to: '/'
      },
      {
        key: 'nosotros',
        name: 'nosotros',
        as: Link,
        to: '/about'
      },
      {
        key: 'productos',
        name: 'Sistar ERP',
        as: Link,
        to: '/products'
      },
      {
        key: 'servicios',
        name: 'servicios',
        as: Link,
        to: '/services'
      },
/*      {
        key: 'testimonios',
        name: 'testimonios',
        as: Link,
        to: '/testimonials'
      },*/
      {
        key: 'soporte',
        name: 'soporte',
        as: Link,
        to: '/support'
      },
      {
        key: 'blog',
        name: 'blog',
        as: Link,
        to: '/blog'
      }
    ];
    let activeIndex = _.findIndex(items, (item) => {
      return !!window.location.pathname.match(new RegExp(`^${item.to}\/*.*$`));
    });
    this.state = {
      activeIndex: activeIndex,
      prevIndex: activeIndex,
      items,
      width: window.innerWidth,
      open: false,
      scrolled: false
    };
  }

  handleWindowSizeChange = () => {
    //this.setState({ width: window.innerWidth });
  };

  handleOpenChange = (value = false) => {
    this.setState({ open: value });

  };

  handleScroll = (e) => {
      var distanceY = window.pageYOffset || document.documentElement.scrollTop;
      var shrinkOn = 150;
      if (distanceY > shrinkOn) {
          this.setState({scrolled: true});
      } else {
        this.setState({scrolled: false});
      }
      this.handleOpenChange(false)
  };

  componentWillMount() {
  window.addEventListener('resize', this.handleWindowSizeChange);
  window.addEventListener('scroll', this.handleScroll);
}

// make sure to remove the listener
// when the component is not mounted anymore
componentWillUnmount() {
  window.removeEventListener('resize', this.handleWindowSizeChange);
  window.removeEventListener('scroll', this.handleOpenChange);
}

  render () {
    let {
      items,
      scrolled,
      activeIndex,
      prevIndex
    } = this.state;

    const scrolledStyle = {
      height: '50px'
    };

    const unscrolledStyle = {
      height: '100px'
    };

    let style = scrolled ? scrolledStyle: unscrolledStyle;

    
    const {open} = this.state;
    let active = !!open? 0: -1;

    const { width } = this.state;
    const isMobile = width <= 767;
    if (isMobile) {
      return (
        <Accordion activeIndex={active} onTitleClick={()=> this.handleOpenChange(!open)}>
        <Accordion.Title>
          <Icon name="content" />
        </Accordion.Title>
        <Accordion.Content>
        <Menu
          activeIndex={activeIndex} color="orange"
          pointing secondary stackable items={items} onItemClick={(e, data) => {
            let index = items.findIndex(el => el.name == data.name);
            let aIndex = index;
    let prevIndex = !!this.state.activeIndex || this.state.activeIndex == 0? this.state.activeIndex: aIndex;
    this.setState({
      activeIndex: aIndex,
      prevIndex,
      open: false
    });

            }}/>
        </Accordion.Content>
        </Accordion>
      );
    }

    

    let colors = {
      0: {
        0: 'orange',
        1: 'orangegreen',
        2: 'orangeblue',
        3: 'orangegrey',
        4: 'orangegrey',
        5: 'orangegrey'
      },
      1: {
        0: 'greenorange',
        1: 'green',
        2: 'greenblue',
        3: 'greengrey',
        4: 'greengrey',
        5: 'greengrey'
      },
      2: {
        0: 'blueorange',
        1: 'bluegreen',
        2: 'blue',
        3: 'bluegrey',
        4: 'bluegrey',
        5: 'bluegrey'
      },
      3: {
        0: 'greyorange',
        1: 'greygreen',
        2: 'greyblue',
        3: 'grey',
        4: 'grey',
        5: 'grey',
        6: 'grey'
      },
      4: {
        0: 'greyorange',
        1: 'greygreen',
        2: 'greyblue',
        3: 'grey',
        4: 'grey',
        5: 'grey',
        6: 'grey'
      },
      5: {
        0: 'greyorange',
        1: 'greygreen',
        2: 'greyblue',
        3: 'grey',
        4: 'grey',
        5: 'grey',
        6: 'grey'
      },
      6: {
        0: 'greyorange',
        1: 'greygreen',
        2: 'greyblue',
        3: 'grey',
        4: 'grey',
        5: 'grey',
        6: 'grey'
      }
    };

    let colorClass = colors[prevIndex][activeIndex];
    
    return (
      <Menu
        activeIndex={activeIndex} inverted color="black"
        pointing secondary compact stackable borderless fluid fixed={'top'} style={style}>
          <Menu.Item fitted style={{padding: '0', margin: '0', border: '0'}}>
            <Image height={'100%'} src={logo} className={colorClass} />
          </Menu.Item>
          {items.map((anItem, index) => <Menu.Item active={activeIndex==index} key={anItem.key} onClick={() => {
            let aIndex = index;
    let prevIndex = !!this.state.activeIndex || this.state.activeIndex == 0? this.state.activeIndex: aIndex;
    this.setState({
      activeIndex: aIndex,
      prevIndex
    });

            }} name={anItem.name} as={Link} to={anItem.to}/>
            )}
            <Menu.Menu position="right">
              <Menu.Item as="a" href="https://twitter.com/SistelArg" target="_blank"><Icon name="twitter" color="grey" inverted size="big"/></Menu.Item>
              <Menu.Item as="a" href="https://www.linkedin.com/company/sistel-argentina-erp/" target="_blank"><Icon name="linkedin" color="grey" inverted size="big"/></Menu.Item>
              <Menu.Item as="a" href="https://www.facebook.com/Sistel-Argentina-232113090190527/" target="_blank"><Icon name="facebook" color="grey" inverted size="big"/></Menu.Item>
              <Menu.Item as="a" href="https://www.instagram.com/sistel_argentina/" target="_blank"><Icon name="instagram" color="grey" inverted size="big"/></Menu.Item>
            </Menu.Menu>
            
        </Menu>
    );

  }
}

export default NavigationView;



// WEBPACK FOOTER //
// ./client/containers/NavigationView.js